export default __webpack_public_path__ + "static/media/ALPACA.f01541dc.png";